var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tiktok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/SocialTiktok",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,2 C20.6568542,2 22,3.34314575 22,5 L22,19 C22,20.6568542 20.6568542,22 19,22 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,5 C2,3.34314575 3.34314575,2 5,2 L19,2 Z M14.3657628,5.5 L12.5037234,5.5 L12.4842692,14.5758213 C12.4842692,15.6893394 11.5009086,16.5666287 10.3873904,16.5666287 C9.27408387,16.5666287 8.37157058,15.6641154 8.37157058,14.5508088 C8.37157058,13.4375022 9.27408387,12.534989 10.3873904,12.534989 C10.4707653,12.534989 10.5504347,12.5498112 10.6314936,12.5595382 L10.6314936,12.5595382 L10.6314936,10.6131975 C10.5504347,10.6081023 10.469839,10.6006912 10.3873904,10.6006912 C8.20605655,10.6006912 6.43773605,12.3690117 6.43773605,14.5503456 C6.43773605,16.7316795 8.20605655,18.5 10.3873904,18.5 C12.5687243,18.5 14.3370448,16.7316795 14.3370448,14.5503456 L14.3370448,14.5503456 L14.3370448,9.20647759 C14.9783124,10.1858723 16.0701502,10.7759419 17.2408074,10.7757785 C17.3475348,10.7752988 17.454183,10.7698891 17.5604112,10.7595667 L17.5604112,10.7595667 L17.5622639,10.7595667 L17.5622639,8.59645122 C15.8877424,8.4740379 14.5413463,7.16978381 14.3657628,5.5 L14.3657628,5.5 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTiktok);
export default __webpack_public_path__ + "static/media/SocialTiktok.0b27abc7acb104607a8f3eef63c4edd1.svg";
export { ForwardRef as ReactComponent };